export default __webpack_public_path__ + "static/media/logo-y.59275115.svg";